import React, { useEffect, useState } from 'react';
import { Card, Col, Row, Button, Spin, message } from 'antd';
import axios from 'axios';
import MilestoneModal from './components/milestone';
import './milestone.css';
const BASE_URL = process.env.REACT_APP_CSC_API_BASE_URL;


const Milestone = () => {
  const [milestones, setMilestones] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [editMode, setEditMode] = useState(false);
  const [editData, setEditData] = useState([]);

  // Fetch milestones
  const fetchMilestones = async () => {
    setLoading(true);
    try {
      const res = await axios.get(`${BASE_URL}streak/milestones`);
      setMilestones(res?.data?.data || []);
      console.log('Fetched milestones:', res?.data?.data);
    } catch (error) {
      message.error('Failed to fetch milestones');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchMilestones();
  }, []);

  const handleAdd = () => {
    setEditMode(false);
    setEditData([]);
    setModalOpen(true);
  };

  const handleEdit = () => {
    setEditMode(true);
    setEditData(milestones);
    setModalOpen(true);
  };

  const handleModalClose = async (refresh = false) => {
    setModalOpen(false);
    if (refresh) {
      await fetchMilestones();
    }
  };

  return (
    <div className="milestone-container">
      <div className="milestone-header">
        <Button type="primary" size="large" onClick={handleAdd} className="milestone-btn">
          Add Milestone
        </Button>
        <Button onClick={handleEdit} size="large" className="milestone-btn">
          Edit Milestones
        </Button>
      </div>
      {loading ? (
        <div className="milestone-spin">
          <Spin size="large" />
        </div>
      ) : (
        <Row gutter={[24, 24]}>
          {milestones?.map((item, idx) => (
            <Col xs={24} sm={12} md={8} key={idx}>
              <Card
                title={<span className="milestone-card-title">{item.Title}</span>}
                bordered={false}
                className="milestone-card"
                headStyle={{ border: 'none', background: '#f5f7fa', borderRadius: '10px 10px 0 0' }}
              >
                <div className="milestone-card-row">
                  <strong>Threshold:</strong> {item.ThresholdTransaction}
                </div>
                <div className="milestone-card-row">
                  <strong>Reward:</strong> {item.Reward}
                </div>
              </Card>
            </Col>
          ))}
        </Row>
      )}
      <MilestoneModal
        open={modalOpen}
        onClose={handleModalClose}
        editMode={editMode}
        initialData={editData}
      />
    </div>
  );
};

export default Milestone;